import { render, staticRenderFns } from "./EmTabs.vue?vue&type=template&id=10db2e37&scoped=true&"
import script from "./EmTabs.vue?vue&type=script&lang=js&"
export * from "./EmTabs.vue?vue&type=script&lang=js&"
import style0 from "./EmTabs.vue?vue&type=style&index=0&id=10db2e37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db2e37",
  null
  
)

export default component.exports